import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const safe = (fn, fallback) => async () => {
  try { return await fn(); } catch { return fallback; }
};

export const useMeta = () => useQuery({
  queryKey: ["meta"],
  queryFn: safe(async () => (await api.get("/meta")).data, { categories: [], colors: [], finishes: [] }),
});

export const useStones = (featured = false) => useQuery({
  queryKey: ["stones", featured],
  queryFn: safe(async () => {
    const d = (await api.get("/stones", { params: featured ? { featured: true } : {} })).data;
    return Array.isArray(d) ? d : [];
  }, []),
});

export const useStone = (code) => useQuery({
  queryKey: ["stone", code],
  enabled: !!code,
  queryFn: async () => {
    try { return (await api.get(`/stones/${encodeURIComponent(code)}`)).data; }
    catch (e) { if (e?.response?.status === 404) return null; throw e; }
  },
  retry: false,
});
